var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#00703E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5838 16.7583L10.5838 11.8932M10.5838 11.8932C10.5838 11.8932 11.6287 11.8816 12.1512 11.8759C12.6736 11.8701 15.025 11.8757 14.999 9.53419C14.973 7.19268 12.6224 7.25047 12.0999 7.25626C11.1818 7.26644 10.5326 7.27364 10.5326 7.27364L10.5838 11.8932ZM10.5838 11.8932L9.11446 11.9095M9 14.5L13.0579 14.4993",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubBlack);
export default __webpack_public_path__ + "static/media/rub-black.470ff81cb5e2ad39de287c9d2975d9b8.svg";
export { ForwardRef as ReactComponent };